import { HttpApiEndpoint, HttpApiGroup, HttpApiSchema } from "@effect/platform";
import * as S from "effect/Schema";
import { PrincipalMiddleware } from "./principal.js";
import { Forbidden } from "./shares.js";
export const LocationScope = S.Union(S.Struct({ kind: S.Literal("all") }), S.Struct({
    kind: S.Literal("specific"),
    location_ids: S.NonEmptyArray(S.UUID),
}));
export const ClientAccessRule = S.Struct({
    id: S.UUID,
    user_id: S.UUID,
    client_id: S.UUID,
    client_name: S.String,
    location_scope: LocationScope,
    created_by: S.NullOr(S.UUID),
    date_created: S.String,
});
export const AccessRuleNotFound = S.Struct({
    _tag: S.Literal("AccessRuleNotFound"),
});
export const AccessRuleAlreadyExists = S.Struct({
    _tag: S.Literal("AccessRuleAlreadyExists"),
});
export const InvalidLocationScope = S.Struct({
    _tag: S.Literal("InvalidLocationScope"),
}).annotations(HttpApiSchema.annotations({ status: 400 }));
export const ListClientAccessRulesParams = S.Struct({ user_id: S.UUID });
export const ListClientAccessRules = HttpApiEndpoint.get("listClientAccessRules", "/admin/client-access")
    .setUrlParams(ListClientAccessRulesParams)
    .addSuccess(S.Struct({ items: S.Array(ClientAccessRule), total: S.NonNegativeInt }))
    .addError(Forbidden, { status: 403 });
export const CreateClientAccessRulePayload = S.Struct({
    user_id: S.UUID,
    client_id: S.UUID,
    location_scope: LocationScope,
});
export const CreateClientAccessRule = HttpApiEndpoint.post("createClientAccessRule", "/admin/client-access/create")
    .setPayload(CreateClientAccessRulePayload)
    .addSuccess(S.Struct({ data: ClientAccessRule }))
    .addError(InvalidLocationScope, { status: 400 })
    .addError(Forbidden, { status: 403 })
    .addError(AccessRuleAlreadyExists, { status: 409 });
export const UpdateClientAccessRulePayload = S.Struct({
    id: S.UUID,
    location_scope: LocationScope,
});
export const UpdateClientAccessRule = HttpApiEndpoint.post("updateClientAccessRule", "/admin/client-access/update")
    .setPayload(UpdateClientAccessRulePayload)
    .addSuccess(S.Struct({ data: ClientAccessRule }))
    .addError(InvalidLocationScope, { status: 400 })
    .addError(Forbidden, { status: 403 })
    .addError(AccessRuleNotFound, { status: 404 });
export const DeleteClientAccessRulePayload = S.Struct({ id: S.UUID });
export const DeleteClientAccessRule = HttpApiEndpoint.post("deleteClientAccessRule", "/admin/client-access/delete")
    .setPayload(DeleteClientAccessRulePayload)
    .addSuccess(S.Struct({ data: S.Struct({ deleted: S.Literal(true) }) }))
    .addError(Forbidden, { status: 403 })
    .addError(AccessRuleNotFound, { status: 404 });
export const adminClientAccessGroup = HttpApiGroup.make("admin-client-access")
    .add(ListClientAccessRules)
    .add(CreateClientAccessRule)
    .add(UpdateClientAccessRule)
    .add(DeleteClientAccessRule)
    .middleware(PrincipalMiddleware);
//# sourceMappingURL=admin-client-access.js.map